import React, { useState, useEffect } from 'react';
import logo from '../../assets/Images/Clanbridge-logo.png2.png';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';
import moment from 'moment/moment';

const ReportTable = ({ columns, rows, title, contentRef }) => {
    const [currentDate, setCurrentDate] = useState(moment(new Date()).format("DD-MM-YYYY"));
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {

        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        setCurrentDate(formattedDate);

        const firstPageRows = 35;
        const otherPageRows = 40;
        let remainingRows = rows.length - firstPageRows;

        const totalPages = remainingRows <= 0 ? 1 : Math.ceil(remainingRows / otherPageRows) + 1;
        setTotalPages(totalPages);
    }, [rows]);

    const generatePages = () => {
        const pages = [];
        const firstPageRows = 35;
        const otherPageRows = 40;

        pages.push(rows.slice(0, firstPageRows));

        let remainingRows = rows.slice(firstPageRows);
        while (remainingRows.length > 0) {
            pages.push(remainingRows.slice(0, otherPageRows));
            remainingRows = remainingRows.slice(otherPageRows);
        }

        return pages;
    };

    const pages = generatePages();

    return (
        <div ref={contentRef}>
            <Container maxWidth="md">
                {logo && (
                    <>
                        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, marginTop: '15px' }}>
                            <img src={logo} style={{ height: '35px' }} alt="logo" />
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body2" align="left" sx={{ marginBottom: '10px' }}>
                                Address:
                            </Typography>
                            <Typography variant="body1" align="right" sx={{ marginBottom: '10px' }}>
                                Date: {currentDate}
                            </Typography>
                        </Box>
                    </>
                )}

                {title && (
                    <Typography
                        variant="h4"
                        gutterBottom
                        align="center"
                        sx={{ borderBottom: '1px solid #000', paddingBottom: '8px' }}
                    >
                        {title}
                    </Typography>
                )}

                {/* Render each page with its own table and header */}
                {pages.map((pageRows, index) => (
                    <div key={index} style={{ pageBreakAfter: 'always' /* Force page break after each page when printing */ }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ borderCollapse: 'separate' }}>
                                <TableHead sx={{ display: 'table-header-group' }}>
                                    <TableRow>
                                        {columns.map(column => (
                                            <TableCell key={column.id} sx={{ fontWeight: 'bold', lineHeight: 1.2, py: 0.5 }}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pageRows.map((row, index) => (
                                        <TableRow key={index} sx={{ pageBreakInside: 'avoid' }}>
                                            {columns.map(column => (
                                                <TableCell key={column.id} sx={{ lineHeight: 1.2, py: 0.5 }}>
                                                    {row[column.id]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{ textAlign: 'right', marginBottom: '20px' }}>
                            <Typography variant="body1">
                                {index + 1}/{totalPages}
                            </Typography>
                        </Box>
                    </div>
                ))}
            </Container>
        </div>
    );
};

export default ReportTable;

